import { WaterMark } from '@ant-design/pro-components';
import type { WaterMarkProps } from '@ant-design/pro-components';
import { useModel } from '@umijs/max';

const wtihWatermark =
    <P extends object>(
        Component: React.ComponentType<P>,
        options: WaterMarkProps = {},
    ) =>
    (props: P) => {
        const { initialState } = useModel('@@initialState');
        return (
            <WaterMark {...getWatermarkConfig(initialState, options)}>
                <Component {...props}></Component>
            </WaterMark>
        );
    };

export default wtihWatermark;

export const getWatermarkConfig = (initialState: any, options = {}) => {
    if (!__bl.username && initialState.userInfo) {
        __bl?.setConfig?.({
            setUsername: function () {
                return initialState.userInfo?.email;
            },
            uid: initialState.userInfo?.userId,
        });
    }

    return {
        content: `${initialState.userInfo?.jobNumber}`,
        width: 280,
        height: 70,
        gapX: 120,
        gapY: 120,
        fontSize: 12,
        fontColor: '#ebe9e9',
        rotate: -10,
        zIndex: 1,
        markStyle: {
            opacity: 0.7,
        },
        ...options,
    };
};
